import { requestWithToken as request } from "./api";

const BASE = "/company_link_requests";

// Solicitud del cliente para que lo agreguen a una empresa (Opción B).
export function createCompanyLinkRequest(payload) {
    return request.post(`${BASE}/`, payload);
}

export function getMyCompanyLinkRequests() {
    return request.get(`${BASE}/mine/`);
}

export function cancelCompanyLinkRequest(id) {
    return request.post(`${BASE}/${id}/cancel/`);
}

export function dismissCompanyLinkRequest(id) {
    return request.post(`${BASE}/${id}/dismiss/`);
}
